module.exports = __webpack_public_path__ + "img/4.af3a9b11.jpg";